exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hours p{color:#000}.hours strong{margin-left:5px}.byline a{color:#000;font-weight:600}.byline a:hover{color:#e8b88b}@media (max-width:420px){.byline{margin-top:10px}}", ""]);

// exports
